<script>
import ProductAction from '@/components/ProductAction';

export default {
  name: 'ProductMixin',
  components: { ProductAction },
  props: {
    menu: { type: String, default: null },
    item: { type: Object, required: true }
  },
  computed: {
    inBasket() {
      const { items } = this.$store.state.basket;
      if (!items || items.length === 0) return 0;
      const { id, name, price } = this.itemForBasket;
      const idx = items.findIndex((o) => o.id === id && o.name === name && o.price === price);
      return idx === -1 ? 0 : items[idx].quantity;
    },
  },
  created() {
    this.data = this.item.commodity;
    this.description = null;
    if (this.data.description && typeof this.data.description === 'string') {
      this.description = { html: this.data.description };
    } else {
      this.description = this.data.description;
    }
    this.name = this.item.commodity.name;
    this.mode = this.getMode(this.item.commodity, this.menu);
    const { theme } = this.$store.state;
    this.theme = {
      dark: theme.productDark,
      color: theme.productColor,
      rounded: theme.productRounded,
      elevation: theme.productElevation,
    };
    this.itemForBasket = this.item;
    /*
    this.itemForBasket = {
      id: this.data._id,
      product: this.item.item._id,
      price: this.data.priceFinal,
      name: this.name
    };
    */
  },
  methods: {
    getMode(data, menu) {
      const { point, points, mode } = this.$store.state.data;
      if (point === null || !points[point]) return 'need_location';
      let inStopList = false;
      if (points[point]) {
        const stop = points[point].stop_products;
        if (stop && Array.isArray(stop)) {
          inStopList = stop.findIndex((stopProd) => stopProd._id === data._id) > -1;
        }
      }
      const menuData = points[point].catalogues.find(({_id}) => _id === menu);
      const pickup = mode === 'pickup';
      if (!pickup && !menuData.time_ok) return 'bad_menu_time';
      if (!pickup && (inStopList || !data.deliverable)) return 'can_not_deliver';
      if (pickup && (inStopList || !data.pickupable)) return 'can_not_pickup';
      if (!points[point].order_time_ok) return 'bad_order_time';
      return 'ok';
    },
    plus() {
      this.$store.dispatch('basket/plus', this.itemForBasket);
    },
    minus() {
      this.$store.dispatch('basket/minus', this.itemForBasket);
    },

  }
};
</script>
